import React from "react";

export default function Navbar({ className = "" }) {
  const categories = [
    "Kitchen Appliances",
    "Electric Tools",
    "AC & Cooling",
    "Home Essentials",
    "Cleaning Tools",
    "Cookware",
    "Smart Home",
    "Outdoor Tools",
    "Bathroom Fixtures",
  ];

  return (
    <nav className={`w-full bg-white dark:bg-slate-900 shadow-md dark:shadow-none border-b border-gray-200 dark:border-slate-700 sticky top-[70px] z-50 ${className}`}>
      <ul className="flex flex-wrap justify-center space-x-6 p-4">
        {categories.map((category, index) => (
          <li key={index}>
            <a
              href={`/category/${category.toLowerCase().replace(/['\s&]+/g, "-")}`}
              className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-[#ff9906] dark:hover:text-[#ff9906] transition-colors"
            >
              {category}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
